
export const ProjectConstants = {
    grievanceNotAvailable: `No grievance available`,
    objectionNotAvailable: `No objection/suggestion available`,
    esacalationNotAvailable: `No escalation duration available`,
    gtypeNotAvailable: `No grievance type available`,
    userNotAvailable: `No user available`,
    objeSuggestionTypeFound:'No Objection/Suggestion type available',
    authanticationFailedCode: `5009`,
    authanticationFailedMsg: `Authentication Fail`,

    networkErMsg: `There was network related or instance related error understanding the request. Please try doing it again`,

    noGtypeFound: `No grievance type found against selected board.`,
    noGtypeFoundInDept: `No grievance type found against selected department.`,
    grievanceSuccessToast: `Your grievance successfully raised!!!`,
    fileSuccessToastMsg: `File downloaded successfully`,
    noAbleToDownloadErMsg: `Not able to download file`,
    noAbleToDownloadErCode: `5005`,
    replySucessMsg: `Sent reply Successfully`,
    transferSuccessmsg: `Transfer grievance successfully`,

    maxFileSize: 700000,
    isSizeChecktrue: "true",
    isSizeCheckfalse: "false",
    responseGriExist: "Grievance Exist",
    responseStatusSuccess: "Success",
    responseStatusFailure: "Failure",

    dialogCloseYes: "Yes",
    attachementExtensionErrorMsg: "Allow Only .jpg, .png, .jpeg  and .pdf files",
    attachmentFileSizeErMsg: "File size must be less than 700KB",
    okMsg: "Ok",
    noMsg: "No",
    yesMsg: "Yes",

    warningMsg: "Warning",
    closeGrievanceMsg: "Do you want to Close Grievance?",
    reopenGrievanceMsg: "Do you want to Reopen Grievance?",
    doYouwantToDelete: "Do you want to delete ",
    doYouwantToDeleteObjectionSugestion: "Do you want to delete Objection/Suggestion type?",

    grievanceSuccessTitle: "Success",
    grievanceSuccessTitleMSg: "Your grievance successfully raised!!!",

    grievanceExistTitle: "Exist",
    grievanceExistTitleMsg: "Grievance type already exist.. Do you want to create another?",
    cancelBtn: "Cancel",

    uiUploadMax3FilesMsg: " User can upload Maximum 3 files ",
    uiFileExtensionMsg: " Upload only .pdf,.png,.jpg,.jpeg files ",
    uiFileSizeMsg: " File size must be less than 700KB ",

    otpValidityExpired: "Validity Expired !!!",
    otpInvalidStatus: "Invalid",
    otpInvalidStatusMsg: "Invalid OTP, Please try again",

    grievanceBackendTimeoutMsg: "Grievance Backend Timeout",
    lotteryBackendTimeoutMsg: "Lottery Backend Timeout",

    resendOtpSuccessToastMsg: "OTP resend successfully!!!..",
    userTypeMhadaUser: "MHADA Internal User",
    userTypeLotteryUser: "Lottery User",

    esacalationAddSuccessMsg: "Escalation Duration successfully added !!!",
    oopsSmtngWentToWrong: "Oops, something went wrong, please try after sometime",
    esaclationDeleteSuccessMsg: "Escalation duration successfully deleted !!!",
    esacalationUpdateSuccessMsg: "Your Escalation Duration successfully updated !!!",
    gtypeSuccessMsg: "Your grievance type successfully added !!!",
    gtypeIsinuseStatusCode: 5007,
    gtypeIsinuseStatusMsg: "Grievance type is in use so cannot be deleted.",
    gtypeDeleteSuccessMsg:"Grievance type successfully deleted !!!",
    gtypeUpdateSuccessMsg:"Your grievance type has been updated successfully!!!",

    objSuggestionaddSuccessMsg:"Your objections/suggestion type successfully added !!!",
    objSuggestionDeleteSuccessMsg:"Your objections/suggestion type successfully deleted !!!",
    objSuggestionIsinUseStatus:"Objection/Suggestion type is in use so cannot be deleted.",
    objSuggestionUpdateSuccessMsg:"Your Objection Suggestion  successfully updated !!!",


    docSplit:"/"

}